import { useState } from "react";
import { Modal } from "../../../../components/Modal";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { colors } from "../../../../components/colors";
import { PrimaryButton } from "../../../../components/Buttons";
import { ChallengeImageWrapper } from "../ChallengeImageWrapper";
import { getErrorMessage } from "../../../../error-handler";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  uploadImage: (request: any) => Promise<string>;
  imageUploadIsLoading: boolean;
  modalHeader: string;
};

export const EditImageModal = ({
  isOpen,
  onClose,
  uploadImage,
  imageUploadIsLoading,
  modalHeader,
}: Props) => {
  const { organization: organizationKeyName, id } = useParams<{
    organization: string;
    id: string;
  }>();
  const { watch, setValue } = useFormContext();
  const [tempImageUrl, setTempImageUrl] = useState<string>("");
  const files = watch("files");

  const fileOnChange = async (acceptedFiles: File[]) => {
    setValue("files", acceptedFiles);
    const file = acceptedFiles[0];
    const request = {
      file,
      id,
      organizationKeyName,
    };
    try {
      const imageUrl = await uploadImage(request);
      setTempImageUrl(imageUrl);
    } catch (error: unknown) {
      const errorMessage = getErrorMessage(error);
      toastr.error("Error", errorMessage);
    }
  };

  const onCloseModal = () => {
    onClose();
    setValue("files", []);
  };

  const onSave = () => {
    onClose();
    setValue("imageUrl", tempImageUrl);
    setValue("files", []);
  };

  const buttonIsDisabled = () => {
    if (!files) {
      return true;
    }
    if (files.length === 0) {
      return true;
    }
    return false;
  };

  return (
    <Modal
      header={modalHeader}
      isOpen={isOpen}
      onClose={onCloseModal}
      width="750px"
    >
      <ChallengeImageWrapper
        file={files && files[0]}
        isLoading={imageUploadIsLoading}
        onDrop={fileOnChange}
      />
      <PrimaryButton
        color={colors.white}
        disabled={buttonIsDisabled()}
        backgroundColor={colors.ctaMain}
        hoverColor={colors.ctaSecondaryOne}
        type="button"
        onClick={onSave}
      >
        Use Image
      </PrimaryButton>
    </Modal>
  );
};
